import React, { Suspense } from 'react';
import SuspenseOverlay from './Shared/Utils/SuspenseOverlay';

const domain = window.location.hostname;

const InstallerPortal = React.lazy(() => import('./Apps/InstallerPortal/InstallerPortal'));
const OrderPortal = React.lazy(() => import('./Apps/OrderPortal/OrderPortal'));
const AppNotFound = React.lazy(() => import('./Apps/AppNotFound/AppNotFound'));

const getComponent = () => {
	switch (domain) {
		case import.meta.env.VITE_INSTALLER_PORTAL_DOMAIN:
			return InstallerPortal;
		case import.meta.env.VITE_ORDER_PORTAL_DOMAIN:
			return OrderPortal;
		default:
			return AppNotFound;
	}
};

export default function App(): JSX.Element {
	const Component = getComponent();

	return (
		<Suspense fallback={<SuspenseOverlay />}>
			<Component />
		</Suspense>
	);
}
